import { Component, OnInit,Inject,ViewChild,ElementRef } from '@angular/core';
import { FileUploader  } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../services/dashboard.service';

import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material";
import { saveAs } from 'file-saver';
var URL = 'http://localhost:8086/api/v1/uploadCheck';
@Component({
  selector: 'app-offlinepayment',
  templateUrl: './offlinepayment.component.html',
  styleUrls: ['./offlinepayment.component.scss']
})
export class OfflinepaymentComponent implements OnInit {
success:boolean  = false;
public uploader: FileUploader = new FileUploader({
  url: URL,
  itemAlias: 'image'
});
@ViewChild('utrNumber', { static: false }) utrNumber: ElementRef<HTMLInputElement>;
isUTRUpdated:boolean = true;
payableAmout;
utrPattern = /^[A-Za-z0-9]{16}$/;
  constructor(private toastr:ToastrService,@Inject(MAT_DIALOG_DATA) public data,private _dashboardService: DashboardService) { }

  ngOnInit() {
  }
  updateUTRNumber(){
    if (!this.utrNumber.nativeElement.value.trim()) {
      alert('Please Enter UTR Number');
      this.isUTRUpdated = false;
  } else{
    this._dashboardService.updateUTRNumber({userid:this.data[0],UTRNumber:this.utrNumber.nativeElement.value}).subscribe((response: any) => {
      if(response.code == 1){
        this.success = true;
        this.isUTRUpdated = true;
      }
    });
  }
}
  upload(){
      if (!this.utrNumber.nativeElement.value.trim()) {
        // Show error message or perform other actions
        alert('Please Enter UTR Number');
        this.isUTRUpdated = false;
      }else if(!this.success){
        this.isUTRUpdated = false;
        alert('Please Submit UTR number');
      } else {
        window.location.reload();
        this.isUTRUpdated = true;
      }
  }
  downloadInvoice(){
    let amount = (Number(this.data[0].amc) *Number(this.data[0].quntity)) * 0.18;
    let periodInYear = Math.round((this.data[0].RenewalDays / 365));
    this.payableAmout = Number(((Number(this.data[0].amc) *Number(this.data[0].quntity)) + amount)*periodInYear).toFixed(2);
    this.data[0].amount = this.payableAmout;
    this.data[0].quntity = this.data[0].quntity;
    this._dashboardService.generateProformaInvoice(this.data[0]).subscribe((response: any) => {
        let downloadURL = window.URL.createObjectURL(response);
        saveAs(downloadURL,'PERFORMAINV'+this.data[0].id);
    });
  }
}
